import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {DateTime} from 'luxon';

const Footer = () => {
    const [t] = useTranslation();

    const [configData, setConfigData] = useState([]);

    const getData=()=>{
        fetch('/config.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            console.log(response)
            return response.json();
          })
          .then(function(myJson) {
            console.log(myJson);
            setConfigData(myJson);
          });
      }

      useEffect(()=>{
        getData()
      },[])

    return (
        <footer className="main-footer">
            <div className="float-right d-none d-sm-block">
                <b>{t('footer.version')}</b>
                <b> </b>
                <span>1.0</span>
            </div>
            <strong>
                <span>Copyright © {DateTime.now().toFormat('y')} </span>
                <a
                    // href="https://erdkse.com"
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    viện 108
                </a>
                <span>.</span>
            </strong>
            <span> </span>
            <span>{t('footer.copyright')}</span>
        </footer>
    );
};

export default Footer;
